import { render } from "./EventList.vue?vue&type=template&id=78af3bbc&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=78af3bbc&scoped=true&lang=css"

import exportComponent from "/Users/sindreglomnes/Documents/Dataing/Testing/VueCourse/real-world-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78af3bbc"]])

export default __exports__